(function( $ ){

	"use strict";

	/*
	*
	*  HTML Templates
	*
	*/

	let html = ( data = {} ) => {

		let title = data.title || '',
			image = data.image.src.large || '',
			spetification_listing = data.meta.spetification_listing || [],
			url   = data.url || '';

		let spetifications = '';

		if ( spetification_listing.length ) {

			$.each(spetification_listing, function(index, spec) {
				
				spetifications += `<strong> ${ spec.label || '' } </strong>
								   <span> ${spec.value || '' } </span>`;	

			});

		};

		let html = 	`<li class='fadeIn animated'>
						<a href="${url}">
							
							<div class="single-product-title-container">
								<h2>
									${title}
								</h2>
							</div>

							<figure>
								<img src="${image}" alt="${title}">
							</figure>

							${spetifications}
					
						</a>
					</li>`;

		return html;

	}


	/*
	*
	*  URL change
	*
	*/
	let urlChange = ( params = '' ) => {

		window.history.replaceState( {} , '' , '#' + params );

	}



	/*
	*
	*  Rest Api
	*
	*/
	$.fn.getProducts = function( data = {} ) {

	    let container   = $(this),
	        paged       = data.paged || 1,
	        tax 		= data.tax || '',
	        tasksParams = `paged=${paged}&tax=${tax}`;


		urlChange( tasksParams );

   		/*
		*
		* AJAX Rest api get tasks
		*
		*/
		$.ajax( {
	     	url: APP.config.url.rest + 'filter/get/?' + tasksParams,
	     	success: function ( data ) {

	          	let result     = data || {},
	              	status     = result.status || 0,
					pagination = result.pagination || 0,
	              	list   	   = result.list || {};

	          	if ( data.status == 1 ) {

	              	container.empty();

	              	if ( list.length ) {

		              	$.each(list, function(index, val) {

		                  	container.append( html( val ) );

		              	});

	              	};

	              	if ( pagination != "" ) {

	              		$('.paging').html( pagination ).show();
	              		// paged
	              		$('.page-numbers').removeClass('current');
						$('.page-numbers:contains("' + paged + '")').addClass('current');


	              	}else{

	              		$('.paging').hide();

	              	}
	              	
	          	}

	     	},
	     	cache: false
	  	});


	    return this;

	}


}( jQuery ));
